import { InstalledBaseNodeRules, InstalledBaseNodeTypeKey } from '../codegen/graphql';
import { childRuleHasRoom, getChildRule, isChildTypeWhitelisted } from './nodeChildRules';
import { InstalledBaseNodeWithPath, isNodeInTrash } from './installedBasePath';

/**
 * Whether the asset dashboard (actions menu, sub-assets widget) offers "Create Sub-Asset"
 * for an asset's installed-base node. Same rules as the tree's column "+": hidden unless
 * ASSET is whitelisted and the user may write; visible-but-disabled at the count limit so
 * the UI can say why.
 */
export interface SubAssetCreationState {
    canOffer: boolean;
    disabled: boolean;
    /** Set when disabled because the ASSET child rule is at its limit. */
    limit?: { current: number; max: number };
}

export interface SubAssetCreationNode extends InstalledBaseNodeWithPath {
    access?: { write?: boolean | null } | null;
    nodeRules?: InstalledBaseNodeRules | null;
}

const NOT_OFFERED: SubAssetCreationState = { canOffer: false, disabled: true };

export const getSubAssetCreationState = (
    node?: SubAssetCreationNode | null
): SubAssetCreationState => {
    if (!node || !node.access?.write || isNodeInTrash(node)) return NOT_OFFERED;
    if (!isChildTypeWhitelisted(node.nodeRules, InstalledBaseNodeTypeKey.ASSET)) return NOT_OFFERED;

    const rule = getChildRule(node.nodeRules, InstalledBaseNodeTypeKey.ASSET);
    if (rule && rule.limits && !childRuleHasRoom(rule)) {
        return {
            canOffer: true,
            disabled: true,
            limit: { current: rule.currentNodeCount, max: rule.limits.max },
        };
    }
    return { canOffer: true, disabled: false };
};
